export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=7069a0593ff5615019b2494d6329518a5b123cf3ca&name=pushAdClickData!'